import React, { Component } from "react"
class CheckoutConsent extends Component {
  handleInputChange(event) {
    const { target } = event
    const value = target.checked
    const name = target.name
    let newConsentInformation = this.props.consentInformation

    newConsentInformation[name] = value
    this.props.updateCheckoutState("consentInformation", newConsentInformation, this.props.getRequiredFields())
  }

  render() {
    const data = this.props.marketingConsentContent
    if (!data || !data.items) return null
    const showAny = data.items.find((i) => !i.dontDisplay)
    if (!showAny) return null

    return (
      <div className="form--parking__marketing">
        <header className="form__header">
          <h4>{data.header}</h4>
        </header>
        {data.items.map((item, index) => {
          if (item.dontDisplay) return null
          return (
            <div key={"" + index} className="form__section form__section--short form__section--light">
              <div className="form__section__inner">
                <div className={"form__field form__field--checkbox is-bound"}>
                  <label className="form__label">
                    <input
                      className="form__item "
                      id={item.consentId}
                      name={item.consentId}
                      type="checkbox"
                      checked={this.props.consentInformation[item.consentId]} //{item.isPreselected}
                      onChange={(event) => this.handleInputChange(event)}
                    />
                    <span className="form__label__text">
                      <h5>
                        {item.header}&nbsp;&nbsp;<strong>&nbsp;</strong>
                      </h5>
                      <span dangerouslySetInnerHTML={{ __html: item.body }}></span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}
export default CheckoutConsent
